import { instance as axios } from '../utils/AxiosInstance';

class RegisterService {


    create(email: string, password: string, solera?: any, eligibility_id?: string) {
        
          return axios.post(`/register`, { email, password, solera, eligibility_id });    

    }
   
}

export default new RegisterService();